import React from 'react';
import { Box, Button, alpha } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../../i18n/useI18n';

const EmailTabs: React.FC = () => {
  const { admin: a } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const value = location.pathname.startsWith('/admin/email-sent') ? 'sent' : 'composer';

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 0.6,
        p: 0.5,
        mb: { xs: 1.75, sm: 2.5 },
        borderRadius: 999,
        bgcolor: alpha('#f48fb1', 0.08),
        border: '1px solid',
        borderColor: alpha('#f48fb1', 0.2),
      }}
    >
      <Button
        onClick={() => navigate('/admin/email-composer')}
        sx={{
          py: { xs: 0.95, sm: 1.05 },
          px: 1,
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 800,
          fontSize: { xs: '0.78rem', sm: '0.9rem' },
          color: value === 'composer' ? '#fff' : '#bf5f82',
          bgcolor: value === 'composer' ? 'primary.main' : 'transparent',
          boxShadow: value === 'composer' ? `0 6px 14px ${alpha('#f48fb1', 0.4)}` : 'none',
          '&:hover': {
            bgcolor: value === 'composer' ? 'primary.dark' : alpha('#f48fb1', 0.12),
          },
        }}
      >
        {a.email.tabCompose}
      </Button>
      <Button
        onClick={() => navigate('/admin/email-sent')}
        sx={{
          py: { xs: 0.95, sm: 1.05 },
          px: 1,
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 800,
          fontSize: { xs: '0.78rem', sm: '0.9rem' },
          color: value === 'sent' ? '#fff' : '#bf5f82',
          bgcolor: value === 'sent' ? 'primary.main' : 'transparent',
          boxShadow: value === 'sent' ? `0 6px 14px ${alpha('#f48fb1', 0.4)}` : 'none',
          '&:hover': {
            bgcolor: value === 'sent' ? 'primary.dark' : alpha('#f48fb1', 0.12),
          },
        }}
      >
        {a.email.tabSent}
      </Button>
    </Box>
  );
};

export default EmailTabs;
